export function CertificateIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M4.33333 13.3334H3.33333C2.59695 13.3334 2 12.7364 2 12V2.66671C2 1.93033 2.59695 1.33337 3.33333 1.33337H12.6667C13.403 1.33337 14 1.93033 14 2.66671V12C14 12.7364 13.403 13.3334 12.6667 13.3334H11.6667M8 12.6667C9.10457 12.6667 10 11.7713 10 10.6667C10 9.56214 9.10457 8.66671 8 8.66671C6.89543 8.66671 6 9.56214 6 10.6667C6 11.7713 6.89543 12.6667 8 12.6667ZM8 12.6667L8.01429 12.6666L5.88578 14.7951L4.00016 12.9095L6.0131 10.8965M8 12.6667L10.1285 14.7951L12.0142 12.9095L10.0012 10.8965M6 4.00004H10M4.66667 6.33337H11.3333'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
